import { useEffect, useState } from "react"

export const TURNSTILE_SCRIPT_URL =
  "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit"

let turnstileScriptPromise = null

export function loadTurnstileScript() {
  if (window.turnstile) return Promise.resolve()

  if (!turnstileScriptPromise) {
    turnstileScriptPromise = new Promise((resolve, reject) => {
      const existing = document.querySelector(
        `script[src="${TURNSTILE_SCRIPT_URL}"]`,
      )
      if (existing) {
        existing.addEventListener("load", () => resolve())
        existing.addEventListener("error", () => reject())
        return
      }

      const script = document.createElement("script")
      script.src = TURNSTILE_SCRIPT_URL
      script.async = true
      script.defer = true
      script.onload = () => resolve()
      script.onerror = () => reject()
      document.head.appendChild(script)
    }).catch((err) => {
      turnstileScriptPromise = null
      throw err
    })
  }

  return turnstileScriptPromise
}

export function useTurnstileReady(enabled) {
  const [ready, setReady] = useState(() => !!window.turnstile)

  useEffect(() => {
    if (!enabled || ready) return

    let cancelled = false
    loadTurnstileScript()
      .then(() => {
        if (!cancelled) setReady(true)
      })
      .catch(() => {
        // Script failed to load — form will submit with null token
        // and the backend/killswitch decides what to do.
      })

    return () => {
      cancelled = true
    }
  }, [enabled, ready])

  return ready
}

export function getTurnstileTheme() {
  const colorScheme = document.body.dataset.colorScheme
  return colorScheme === "dark" ? "dark" : "light"
}
